module.exports = __webpack_public_path__ + "img/mannul_home_edit-openclose.191d7049.png";